import type { StandardText } from '@buying/library';

const generateStandardTextFieldHelperText = (value: string): string =>
    `${value ? value.length : 0} / 4000 characters used`;

const getStandardTextsFromNumbers = (
    standardTexts: Array<StandardText>,
    textNumbers: Array<StandardText['standardTextNumber']> | null
): Array<StandardText> | null => {
    if (!textNumbers || textNumbers.length === 0) {
        return null;
    }

    const filteredStandardTexts = standardTexts.filter((standardText) =>
        textNumbers.includes(standardText.standardTextNumber)
    );

    if (filteredStandardTexts.length === 0) {
        return null;
    }

    return filteredStandardTexts;
};

const joinStandardTexts = (standardTexts: Array<StandardText>): string =>
    standardTexts.map((standardText) => standardText.standardText).join('\n\n');

export {
    generateStandardTextFieldHelperText,
    getStandardTextsFromNumbers,
    joinStandardTexts,
};
